export const en = {
  common: {
    search: "Search...",
    loading: "Loading...",
    error: "Error",
    status: "Status",
    priority: "Priority",
    date: "Date",
    created: "Created",
    user: "User",
    actions: "Actions",
    cancel: "Cancel",
    save: "Save Changes",
    submit: "Submit",
    submitting: "Submitting...",
    edit: "Edit",
    view: "View",
    delete: "Delete",
    loadingAnalysis: "Loading analysis...",
    title: "Title"
  },
  sidebar: {
    dashboard: "Dashboard",
    submitIncident: "Submit Incident",
    suggestions: "Suggestions",
    incidentLogs: "Incident Logs",
    incidents: "Incidents",
    company: "Company",
    companies: "Companies",
    users: "Users",
    statistics: "Statistics",
    myCompany: "My Company"
  },
  dashboard: {
    title: "Dashboard",
    subtitle: "Overview of incident metrics and recent activity",
    reportNew: "Report New Incident",
    viewLogs: "View All Logs",
    totalIncidents: "Total Incidents",
    pending: "Pending",
    pendingSubtext: "Open & In Progress",
    resolved: "Resolved",
    avgResolution: "Avg. Resolution",
    commonCategory: "Common Category",
    mostFrequent: "Most frequently reported incident type",
    resolutionRate: "Resolution Rate",
    percentageResolved: "Percentage of incidents resolved",
    recentIncidents: "Recent Incidents",
    viewAll: "View All",
    noIncidents: "No incidents found."
  },
  incidentList: {
    title: "Incident Logs",
    subtitle: "View and manage all reported incidents",
    searchPlaceholder: "Search incidents...",
    noIncidentsTitle: "No Incidents Found",
    noIncidentsMsg: "There are no incidents recorded in the system.",
    previous: "Previous",
    next: "Next",
    page: "Page"
  },
  submitIncident: {
    title: "Create Incident Report",
    subtitle: "Provide detailed information about the technical issue you encountered",
    descriptionLabel: "Incident Description *",
    descriptionPlaceholder: "Describe the incident in detail... Include what happened, when it started, which systems are affected, and any error messages you encountered.",
    priorityLabel: "Priority Level",
    submitButton: "Submit Incident Report",
    analyzingButton: "Analyzing & Creating Incident...",
    successTitle: "Incident Created Successfully!",
    createAnother: "Create Another Incident",
    viewAll: "View All Incidents",
    moreContext: "Give more context",
    contextTips: "\n\nAdditional Context:\n- Steps to reproduce:\n- Expected behavior:\n- Actual behavior:\n- Environment (Prod/Stage/Dev):",
    tipsTitle: "Quick Tips",
    priorityTitle: "Priority Levels",
    needHelpTitle: "Need Help?",
    contactSupport: "Contact Support",
    analysisGenerating: "Generating Suggestions...",
    analysisGeneratingMsg: "AI is analyzing your incident details.",
    analysisFailed: "Analysis Failed"
  },
  incidentDetail: {
    notFound: "Incident Not Found",
    notFoundMsg: "The incident you are looking for does not exist.",
    createdOn: "Created on",
    reportedBy: "Reported By",
    description: "Description",
    tags: "Tags",
    analysisTitle: "Incident Analysis",
    history: "Incident History",
    hideHistory: "Hide History",
    viewHistory: "View History",
    selectAnalysis: "Analysis",
    latest: "Latest"
  },
  status: {
    open: "Open",
    in_progress: "In Progress",
    resolved: "Resolved",
    closed: "Closed"
  },
  priority: {
    low: "Low",
    medium: "Medium",
    high: "High",
    critical: "Critical"
  },
  priorityLevels: {
    critical: "System down",
    high: "Major functionality affected",
    medium: "Minor issues",
    low: "Enhancement requests"
  },
  tips: {
    0: "Include specific error messages",
    1: "Mention affected systems",
    2: "Describe impact on users",
    3: "Note when issue started"
  },
  company: {
    title: "Company Management",
    createButton: "Create Company",
    listTitle: "Existing Companies",
    error: "Failed to load companies.",
    noCompaniesTitle: "No Companies Found",
    noCompaniesMsg: "There are no companies registered in the system. Create one to get started."
  }
};
